import {
  AnswerItem,
  ChatFormItem,
  ChatItem,
  ChatItemForm,
  ChatItemKBEntry,
  ChatItemLocationResults,
  ChatItemMessage,
  ChatItemRedirect,
  ChatItemType,
} from 'app/services/chatBot';
import React from 'react';

import { ChatHandlerParams } from '../../types/chat';
import FormChatItem from './FormChatItem';
import LocationResultsChatItem from './LocationResultsChatItem';
import MessageChatItem from './MessageChatItem';
import RedirectChatItem from './RedirectChatItem';
import RedirectToLiveChatItem from './RedirectToLiveChatItem';
import KBEntryChatItem from './KBEntryChatItem';

export default function ChatItemFactory({
  chatItem,
  answerItem,
  onAnswer,
  onDismiss,
  onClickContent,
  onDisplayFormItem,
  hideAvatar,
  className,
  previousUserMessage,
  shouldAnimate,
}: {
  chatItem: ChatItem;
  answerItem?: AnswerItem;
  onAnswer: (params: ChatHandlerParams) => Promise<void>;
  onDismiss: (params: ChatHandlerParams) => Promise<void>;
  onClickContent?: (e: React.MouseEvent, chatItem: ChatItemMessage) => void;
  onDisplayFormItem?: (formItem: ChatFormItem, chatItem: ChatItemForm) => void;
  hideAvatar?: boolean;
  className?: string;
  previousUserMessage?: string;
  shouldAnimate?: boolean;
}) {
  switch (chatItem.type) {
    case ChatItemType.MESSAGE:
      return (
        <MessageChatItem
          chatItem={chatItem as ChatItemMessage}
          hideAvatar={hideAvatar}
          onClickContent={onClickContent}
          className={className}
        />
      );
    case ChatItemType.FORM:
      return (
        <FormChatItem
          shouldAnimate={shouldAnimate}
          className={className}
          answerItem={answerItem}
          chatItem={chatItem as ChatItemForm}
          onAnswer={onAnswer}
          onDismiss={onDismiss}
          onDisplayFormItem={onDisplayFormItem}
        />
      );
    case ChatItemType.REDIRECT_LINK:
      return <RedirectChatItem chatItem={chatItem as ChatItemRedirect} />;
    case ChatItemType.TRANSFER_TO_LIVECHAT:
      return <RedirectToLiveChatItem />;
    case ChatItemType.LOCATION_RESULTS:
      return <LocationResultsChatItem chatItem={chatItem as ChatItemLocationResults} />;
    case ChatItemType.KB_ENTRY:
      return (
        <KBEntryChatItem
          className={className}
          chatItem={chatItem as ChatItemKBEntry}
          highlightTerms={previousUserMessage}
        />
      );
    default:
      return null;
  }
}
